import "./resetMyPass.scss";
import React, { useContext, useEffect, useState } from "react";
/* import { useNavigate } from "react-router-dom"; */
import {
  Container,
  Box,
  Alert,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Stack,
} from "@mui/material";
import { PageLayoutDoctor } from "../../../components/page/page-layout-doctor";
/* import { Budget } from "../../components/dashboard/budget";
import { AppsListToolbar } from "../../components/dashboard/apps-list-toolbar";
import { AppsListResults } from "../../components/dashboard/app-list-results";
import { DialogComponent } from "../../components/dialog-component"; */
import { GlobalContext } from "../../../context/Provider";
import getAplications from "../../../context/actions/aplications/getAplications";
import { useFormik } from "formik";
import { DoctorNewPassSchema } from "../../../helpers/validation";
import LoadingButton from "@mui/lab/LoadingButton";
import axios from "axios";
import { API_BASE_URL } from "../../../constants/apiConstants";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { logoutDoctor } from "../../../utils";
import { getDecryptedDataFromSessionStorage } from "../../../utils";
import { SECRET_KEY } from "../../../constants/encriptKey";

const ResetMyPassDoctor = (props) => {

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
 

  //const { onSubmit, loading, error } = props;
  const [values, setValues] = React.useState({
    showCurrentPassword: false,
    showNewPassword: false,
    showRePassword: false,
  });

  const handleClickShowCurrentPassword = () => {
    setValues({
      ...values,
      showCurrentPassword: !values.showCurrentPassword,
    });
  };

  const handleClickShowNewPassword = () => {
    setValues({
      ...values,
      showNewPassword: !values.showNewPassword,
    });
  };

  const handleClickShowRePassword = () => {
    setValues({
      ...values,
      showRePassword: !values.showRePassword,
    });
  };

  const handleMouseDownCurrentPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseDownNewPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseDownRePassword = (event) => {
    event.preventDefault();
  };

  const formik = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      rePassword: "",
    },
    validationSchema: DoctorNewPassSchema,
    onSubmit: async (values) => {
      const data = getDecryptedDataFromSessionStorage(SECRET_KEY);
      const { idUsuario, accessToken } = data

      try {
        setLoading(true);
        // Obtener idUsuario del localStorage
        //const idUsuario = idUsuario;
        console.log(`idUsuario ${idUsuario}`);

        // Verificar si idUsuario existe
        if (!idUsuario) {
          console.error("No se encontró el idUsuario en el localStorage");
          return;
        }

        const response = await axios.put(
          `${API_BASE_URL}Medicos/CambioContrasenaActual`,
          {
            idUsuario: idUsuario,
            passActual: values.currentPassword,
            passNueva: values.newPassword,
          },
          {
            headers: {
              accept: "text/plain",
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        console.log(`cambioPassResponse: ${JSON.stringify(response)}`);

        // Mostrar mensaje
        if (response.data.status !== "Error") {
          resetForm();
          setMessage({
            type: "success",
            text: "¡Su contraseña se cambió de forma exitosa!",
          });
        } else if (response.data.status === "Error") {
          logoutDoctor();
          window.location.href = "/";
        } else {
          setMessage({
            type: "error",
            text: response.data?.errors?.join(),
          });
        }
      } catch (error) {
        // Mostrar mensaje de error
        setMessage({
          type: "error",
          text:
            error.response.data.message ||
            "Hubo un error al cambiar la contraseña.",
        });
      } finally {
        setLoading(false);
      }
    },
  });

  const resetForm = () => {
    formik.resetForm(); // Esta función restablece los valores del formulario a sus valores iniciales.
  };

  return (
    <PageLayoutDoctor>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2,
        }}
      >
        <Container maxWidth={false}>
          <form onSubmit={formik.handleSubmit}>
            <Card
              sx={{
                border: "0.5px solid #dddddd",
                padding: "1px",
                boxShadow: "1px 1px #dddddd",
              }}
            >
              <CardHeader
                subheader="Complete los datos del formulario para cambiar su contraseña"
                title="Cambio de contraseña"
              />
              <Divider />
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      type={values.showCurrentPassword ? "text" : "password"}
                      error={Boolean(
                        formik.touched.currentPassword &&
                          formik.errors.currentPassword
                      )}
                      fullWidth
                      helperText={
                        formik.touched.currentPassword &&
                        formik.errors.currentPassword
                      }
                      label="Contraseña actual"
                      name="currentPassword"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.currentPassword}
                      variant="outlined"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowCurrentPassword}
                              onMouseDown={handleMouseDownCurrentPassword}
                              edge="end"
                            >
                              {values.showCurrentPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      type={values.showNewPassword ? "text" : "password"}
                      error={Boolean(
                        formik.touched.newPassword && formik.errors.newPassword
                      )}
                      fullWidth
                      helperText={
                        formik.touched.newPassword && formik.errors.newPassword
                      }
                      label="Nueva contraseña"
                      name="newPassword"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.newPassword}
                      variant="outlined"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowNewPassword}
                              onMouseDown={handleMouseDownNewPassword}
                              edge="end"
                            >
                              {values.showNewPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      type={values.showRePassword ? "text" : "password"}
                      error={Boolean(
                        formik.touched.rePassword && formik.errors.rePassword
                      )}
                      fullWidth
                      helperText={
                        formik.touched.rePassword && formik.errors.rePassword
                      }
                      label="Repetir contraseña"
                      name="rePassword"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.rePassword}
                      variant="outlined"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowRePassword}
                              onMouseDown={handleMouseDownRePassword}
                              edge="end"
                            >
                              {values.showRePassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between", // Distribuye los elementos al final y al principio
                  alignItems: "center", // Alinea al centro verticalmente
                  p: 2,
                }}
              >
                <Stack
                  sx={{ width: "auto" }} // Ancho del 60% para el mensaje
                  spacing={2}
                >
                  {message && (
                    <Alert fullWidth severity={message.type}>
                      {message.text}
                    </Alert>
                  )}
                </Stack>
                <LoadingButton
                  loading={loading}
                  color="primary"
                  size="large"
                  type="submit"
                  variant="contained"
                  sx={{ ml: 2 }} // Margen a la izquierda del botón
                >
                  Cambiar contraseña
                </LoadingButton>
              </Box>
            </Card>
          </form>
        </Container>
      </Box>
    </PageLayoutDoctor>
  );
};

export default ResetMyPassDoctor;
